
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/interview/urban-gate",
      function () {
        return require("private-next-pages/interview/urban-gate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/interview/urban-gate"])
      });
    }
  